/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RawRateSummaryCharge } from './RawRateSummaryCharge';
import {
    RawRateSummaryChargeFromJSON,
    RawRateSummaryChargeFromJSONTyped,
    RawRateSummaryChargeToJSON,
    RawRateSummaryChargeToJSONTyped,
} from './RawRateSummaryCharge';
import type { Perks } from './Perks';
import {
    PerksFromJSON,
    PerksFromJSONTyped,
    PerksToJSON,
    PerksToJSONTyped,
} from './Perks';
import type { PointsAmount } from './PointsAmount';
import {
    PointsAmountFromJSON,
    PointsAmountFromJSONTyped,
    PointsAmountToJSON,
    PointsAmountToJSONTyped,
} from './PointsAmount';
import type { MerchantOfRecord } from './MerchantOfRecord';
import {
    MerchantOfRecordFromJSON,
    MerchantOfRecordFromJSONTyped,
    MerchantOfRecordToJSON,
    MerchantOfRecordToJSONTyped,
} from './MerchantOfRecord';
import type { FreeNights } from './FreeNights';
import {
    FreeNightsFromJSON,
    FreeNightsFromJSONTyped,
    FreeNightsToJSON,
    FreeNightsToJSONTyped,
} from './FreeNights';
import type { RateType } from './RateType';
import {
    RateTypeFromJSON,
    RateTypeFromJSONTyped,
    RateTypeToJSON,
    RateTypeToJSONTyped,
} from './RateType';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 * 
 * @export
 * @interface RawRateSummary
 */
export interface RawRateSummary {
    /**
     * The gondola rate ID for the rate
     * @type {number}
     * @memberof RawRateSummary
     */
    gondolaRateId?: number;
    /**
     * 
     * @type {string}
     * @memberof RawRateSummary
     */
    rateId: string;
    /**
     * 
     * @type {number}
     * @memberof RawRateSummary
     */
    vervotechPropertyId: number;
    /**
     * 
     * @type {string}
     * @memberof RawRateSummary
     */
    checkin: string;
    /**
     * 
     * @type {string}
     * @memberof RawRateSummary
     */
    checkout: string;
    /**
     * 
     * @type {string}
     * @memberof RawRateSummary
     */
    occupancy: string;
    /**
     * If the rate is refundable or not
     * @type {boolean}
     * @memberof RawRateSummary
     */
    refundable?: boolean;
    /**
     * If the rate is commissionable or not
     * @type {boolean}
     * @memberof RawRateSummary
     */
    commissionable?: boolean;
    /**
     * If the rate is accessible or not
     * @type {boolean}
     * @memberof RawRateSummary
     */
    accessible?: boolean;
    /**
     * If the rate is a member rate or not
     * @type {boolean}
     * @memberof RawRateSummary
     */
    memberRate?: boolean;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RawRateSummary
     */
    totalRoomBaseRate?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RawRateSummary
     */
    averageNightlyRate?: CurrencyAmount;
    /**
     * 
     * @type {PointsAmount}
     * @memberof RawRateSummary
     */
    averageNightlyPointsRate?: PointsAmount;
    /**
     * 
     * @type {Array<RawRateSummaryCharge>}
     * @memberof RawRateSummary
     */
    nightlyRoomBaseRates: Array<RawRateSummaryCharge>;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RawRateSummary
     */
    taxesAndFees?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RawRateSummary
     */
    propertyFee?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RawRateSummary
     */
    subTotal?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RawRateSummary
     */
    totalDueToday?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RawRateSummary
     */
    totalDueAtProperty?: CurrencyAmount;
    /**
     * 
     * @type {Array<RawRateSummaryCharge>}
     * @memberof RawRateSummary
     */
    deposits: Array<RawRateSummaryCharge>;
    /**
     * 
     * @type {Array<RawRateSummaryCharge>}
     * @memberof RawRateSummary
     */
    chargesDueAtProperty: Array<RawRateSummaryCharge>;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RawRateSummary
     */
    totalCash?: CurrencyAmount;
    /**
     * 
     * @type {PointsAmount}
     * @memberof RawRateSummary
     */
    totalPoints?: PointsAmount;
    /**
     * Score for this exact points redemption on a 0-10 scale, where 10 is a great deal.
     * @type {number}
     * @memberof RawRateSummary
     */
    pointsDealScore?: number;
    /**
     * 
     * @type {MerchantOfRecord}
     * @memberof RawRateSummary
     */
    merchantOfRecord: MerchantOfRecord;
    /**
     * If refundable, simplified information about cancellation. This is not the full cancellation policy.
     * @type {string}
     * @memberof RawRateSummary
     */
    cancellationSummary?: string;
    /**
     * The full cancellation policy
     * @type {Array<string>}
     * @memberof RawRateSummary
     */
    cancellationPolicyFull?: Array<string>;
    /**
     * 
     * @type {PointsAmount}
     * @memberof RawRateSummary
     */
    earningsPoints?: PointsAmount;
    /**
     * 
     * @type {PointsAmount}
     * @memberof RawRateSummary
     */
    earningsCreditCardPoints?: PointsAmount;
    /**
     * The last four digits of the credit card used to book the rate
     * @type {string}
     * @memberof RawRateSummary
     */
    creditCardLastFour?: string;
    /**
     * The number of nights earned for a given stay
     * @type {number}
     * @memberof RawRateSummary
     */
    statusNights?: number;
    /**
     * The points multiplier extracted from the rate name (e.g., 2 for "2x Points", 3 for "3x Points"). Defaults to 1 (no multiplier).
     * @type {number}
     * @memberof RawRateSummary
     */
    rateMultiplier?: number;
    /**
     * Bonus points included in the rate (e.g., 250 for "250 Bonus Points")
     * @type {number}
     * @memberof RawRateSummary
     */
    bonusPoints?: number;
    /**
     * Points bought as a paid add-on included in the rate (e.g., 5000 for IHG "+ 5000 PTS NT" rates)
     * @type {number}
     * @memberof RawRateSummary
     */
    pointsPurchaseAmount?: number;
    /**
     * 
     * @type {RateType}
     * @memberof RawRateSummary
     */
    rateType: RateType;
    /**
     * Concrete supplier inventory behind a product-facing alias such as Gondola Cash.
     * @type {RateType}
     * @memberof RawRateSummary
     */
    inventoryRateType?: RateType;
    /**
     * The rate token required for a price check
     * @type {string}
     * @memberof RawRateSummary
     */
    rateToken?: string;
    /**
     * The booking token required for a booking
     * @type {string}
     * @memberof RawRateSummary
     */
    bookingToken?: string;
    /**
     * The rate name as defined by the supplier
     * @type {string}
     * @memberof RawRateSummary
     */
    supplierRateName?: string;
    /**
     * The raw pre-`get_terms` `rate_description` from the Travelport availability response, stored verbatim.
     * Used as the `rate_refundable_lookup` cache key (GON-5303) — must NOT be passed through `fix_rate_name` or any other canonicalization.
     * Null for non-Travelport rates and for rows created before the column was added.
     * 
     * @type {string}
     * @memberof RawRateSummary
     */
    rawRateDescription?: string;
    /**
     * The rate code as defined by the supplier
     * @type {string}
     * @memberof RawRateSummary
     */
    supplierRateCode?: string;
    /**
     * Additional rate information
     * @type {Array<string>}
     * @memberof RawRateSummary
     */
    additionalRateInfo?: Array<string>;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RawRateSummary
     */
    gondolaEarnings?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RawRateSummary
     */
    totalEarnings?: CurrencyAmount;
    /**
     * 
     * @type {Perks}
     * @memberof RawRateSummary
     */
    perks?: Perks;
    /**
     * Whether the rate needs a rules call
     * @type {boolean}
     * @memberof RawRateSummary
     */
    needsRulesCall?: boolean;
    /**
     * The date the user last updated the rate
     * @type {Date}
     * @memberof RawRateSummary
     */
    userUpdatedAt?: Date;
    /**
     * 
     * @type {FreeNights}
     * @memberof RawRateSummary
     */
    freeNights?: FreeNights;
}



/**
 * Check if a given object implements the RawRateSummary interface.
 */
export function instanceOfRawRateSummary(value: object): value is RawRateSummary {
    if (!('rateId' in value) || value['rateId'] === undefined) return false;
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    if (!('checkin' in value) || value['checkin'] === undefined) return false;
    if (!('checkout' in value) || value['checkout'] === undefined) return false;
    if (!('occupancy' in value) || value['occupancy'] === undefined) return false;
    if (!('nightlyRoomBaseRates' in value) || value['nightlyRoomBaseRates'] === undefined) return false;
    if (!('deposits' in value) || value['deposits'] === undefined) return false;
    if (!('chargesDueAtProperty' in value) || value['chargesDueAtProperty'] === undefined) return false;
    if (!('merchantOfRecord' in value) || value['merchantOfRecord'] === undefined) return false;
    if (!('rateType' in value) || value['rateType'] === undefined) return false;
    return true;
}

export function RawRateSummaryFromJSON(json: any): RawRateSummary {
    return RawRateSummaryFromJSONTyped(json, false);
}

export function RawRateSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RawRateSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'gondolaRateId': json['gondola_rate_id'] == null ? undefined : json['gondola_rate_id'],
        'rateId': json['rate_id'],
        'vervotechPropertyId': json['vervotech_property_id'],
        'checkin': json['checkin'],
        'checkout': json['checkout'],
        'occupancy': json['occupancy'],
        'refundable': json['refundable'] == null ? undefined : json['refundable'],
        'commissionable': json['commissionable'] == null ? undefined : json['commissionable'],
        'accessible': json['accessible'] == null ? undefined : json['accessible'],
        'memberRate': json['member_rate'] == null ? undefined : json['member_rate'],
        'totalRoomBaseRate': json['total_room_base_rate'] == null ? undefined : CurrencyAmountFromJSON(json['total_room_base_rate']),
        'averageNightlyRate': json['average_nightly_rate'] == null ? undefined : CurrencyAmountFromJSON(json['average_nightly_rate']),
        'averageNightlyPointsRate': json['average_nightly_points_rate'] == null ? undefined : PointsAmountFromJSON(json['average_nightly_points_rate']),
        'nightlyRoomBaseRates': ((json['nightly_room_base_rates'] as Array<any>).map(RawRateSummaryChargeFromJSON)),
        'taxesAndFees': json['taxes_and_fees'] == null ? undefined : CurrencyAmountFromJSON(json['taxes_and_fees']),
        'propertyFee': json['property_fee'] == null ? undefined : CurrencyAmountFromJSON(json['property_fee']),
        'subTotal': json['sub_total'] == null ? undefined : CurrencyAmountFromJSON(json['sub_total']),
        'totalDueToday': json['total_due_today'] == null ? undefined : CurrencyAmountFromJSON(json['total_due_today']),
        'totalDueAtProperty': json['total_due_at_property'] == null ? undefined : CurrencyAmountFromJSON(json['total_due_at_property']),
        'deposits': ((json['deposits'] as Array<any>).map(RawRateSummaryChargeFromJSON)),
        'chargesDueAtProperty': ((json['charges_due_at_property'] as Array<any>).map(RawRateSummaryChargeFromJSON)),
        'totalCash': json['total_cash'] == null ? undefined : CurrencyAmountFromJSON(json['total_cash']),
        'totalPoints': json['total_points'] == null ? undefined : PointsAmountFromJSON(json['total_points']),
        'pointsDealScore': json['points_deal_score'] == null ? undefined : json['points_deal_score'],
        'merchantOfRecord': MerchantOfRecordFromJSON(json['merchant_of_record']),
        'cancellationSummary': json['cancellation_summary'] == null ? undefined : json['cancellation_summary'],
        'cancellationPolicyFull': json['cancellation_policy_full'] == null ? undefined : json['cancellation_policy_full'],
        'earningsPoints': json['earnings_points'] == null ? undefined : PointsAmountFromJSON(json['earnings_points']),
        'earningsCreditCardPoints': json['earnings_credit_card_points'] == null ? undefined : PointsAmountFromJSON(json['earnings_credit_card_points']),
        'creditCardLastFour': json['credit_card_last_four'] == null ? undefined : json['credit_card_last_four'],
        'statusNights': json['status_nights'] == null ? undefined : json['status_nights'],
        'rateMultiplier': json['rate_multiplier'] == null ? undefined : json['rate_multiplier'],
        'bonusPoints': json['bonus_points'] == null ? undefined : json['bonus_points'],
        'pointsPurchaseAmount': json['points_purchase_amount'] == null ? undefined : json['points_purchase_amount'],
        'rateType': RateTypeFromJSON(json['rate_type']),
        'inventoryRateType': json['inventory_rate_type'] == null ? undefined : RateTypeFromJSON(json['inventory_rate_type']),
        'rateToken': json['rate_token'] == null ? undefined : json['rate_token'],
        'bookingToken': json['booking_token'] == null ? undefined : json['booking_token'],
        'supplierRateName': json['supplier_rate_name'] == null ? undefined : json['supplier_rate_name'],
        'rawRateDescription': json['raw_rate_description'] == null ? undefined : json['raw_rate_description'],
        'supplierRateCode': json['supplier_rate_code'] == null ? undefined : json['supplier_rate_code'],
        'additionalRateInfo': json['additional_rate_info'] == null ? undefined : json['additional_rate_info'],
        'gondolaEarnings': json['gondola_earnings'] == null ? undefined : CurrencyAmountFromJSON(json['gondola_earnings']),
        'totalEarnings': json['total_earnings'] == null ? undefined : CurrencyAmountFromJSON(json['total_earnings']),
        'perks': json['perks'] == null ? undefined : PerksFromJSON(json['perks']),
        'needsRulesCall': json['needs_rules_call'] == null ? undefined : json['needs_rules_call'],
        'userUpdatedAt': json['user_updated_at'] == null ? undefined : (new Date(json['user_updated_at'])),
        'freeNights': json['free_nights'] == null ? undefined : FreeNightsFromJSON(json['free_nights']),
    };
}

export function RawRateSummaryToJSON(json: any): RawRateSummary {
    return RawRateSummaryToJSONTyped(json, false);
}

export function RawRateSummaryToJSONTyped(value?: RawRateSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gondola_rate_id': value['gondolaRateId'],
        'rate_id': value['rateId'],
        'vervotech_property_id': value['vervotechPropertyId'],
        'checkin': value['checkin'],
        'checkout': value['checkout'],
        'occupancy': value['occupancy'],
        'refundable': value['refundable'],
        'commissionable': value['commissionable'],
        'accessible': value['accessible'],
        'member_rate': value['memberRate'],
        'total_room_base_rate': CurrencyAmountToJSON(value['totalRoomBaseRate']),
        'average_nightly_rate': CurrencyAmountToJSON(value['averageNightlyRate']),
        'average_nightly_points_rate': PointsAmountToJSON(value['averageNightlyPointsRate']),
        'nightly_room_base_rates': ((value['nightlyRoomBaseRates'] as Array<any>).map(RawRateSummaryChargeToJSON)),
        'taxes_and_fees': CurrencyAmountToJSON(value['taxesAndFees']),
        'property_fee': CurrencyAmountToJSON(value['propertyFee']),
        'sub_total': CurrencyAmountToJSON(value['subTotal']),
        'total_due_today': CurrencyAmountToJSON(value['totalDueToday']),
        'total_due_at_property': CurrencyAmountToJSON(value['totalDueAtProperty']),
        'deposits': ((value['deposits'] as Array<any>).map(RawRateSummaryChargeToJSON)),
        'charges_due_at_property': ((value['chargesDueAtProperty'] as Array<any>).map(RawRateSummaryChargeToJSON)),
        'total_cash': CurrencyAmountToJSON(value['totalCash']),
        'total_points': PointsAmountToJSON(value['totalPoints']),
        'points_deal_score': value['pointsDealScore'],
        'merchant_of_record': MerchantOfRecordToJSON(value['merchantOfRecord']),
        'cancellation_summary': value['cancellationSummary'],
        'cancellation_policy_full': value['cancellationPolicyFull'],
        'earnings_points': PointsAmountToJSON(value['earningsPoints']),
        'earnings_credit_card_points': PointsAmountToJSON(value['earningsCreditCardPoints']),
        'credit_card_last_four': value['creditCardLastFour'],
        'status_nights': value['statusNights'],
        'rate_multiplier': value['rateMultiplier'],
        'bonus_points': value['bonusPoints'],
        'points_purchase_amount': value['pointsPurchaseAmount'],
        'rate_type': RateTypeToJSON(value['rateType']),
        'inventory_rate_type': RateTypeToJSON(value['inventoryRateType']),
        'rate_token': value['rateToken'],
        'booking_token': value['bookingToken'],
        'supplier_rate_name': value['supplierRateName'],
        'raw_rate_description': value['rawRateDescription'],
        'supplier_rate_code': value['supplierRateCode'],
        'additional_rate_info': value['additionalRateInfo'],
        'gondola_earnings': CurrencyAmountToJSON(value['gondolaEarnings']),
        'total_earnings': CurrencyAmountToJSON(value['totalEarnings']),
        'perks': PerksToJSON(value['perks']),
        'needs_rules_call': value['needsRulesCall'],
        'user_updated_at': value['userUpdatedAt'] == null ? value['userUpdatedAt'] : value['userUpdatedAt'].toISOString(),
        'free_nights': FreeNightsToJSON(value['freeNights']),
    };
}

